import { z } from 'zod';

export const pageQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(20),
  cursor: z.string().optional(),
});

export type PageQuery = z.infer<typeof pageQuerySchema>;

export interface PageInfo {
  nextCursor: string | null;
  hasNextPage: boolean;
  total: number;
}
